import { atom } from "jotai";

/**
 * Whether the React Query devtools panel is up.
 *
 * Its own module, holding nothing but the atom, so that the header control can
 * read it without pulling tanstack's devtools into the module graph — see
 * {@link QueryDevtools}, which is the only thing that imports them.
 *
 * An atom because the two ends are far apart: the panel is mounted at the app
 * root, where it has the viewport to position against, and the control that
 * opens it rides whichever panel header is topmost.
 */
export const queryDevtoolsOpenAtom = atom(false);
